export const ADMIN_PRIMARY = '#3C2479';
export const ADMIN_PRIMARY_HOVER = '#322066';

export const ADMIN_DEEP_VIOLET = ADMIN_PRIMARY_HOVER;

export const ADMIN_SOFT_BG = '#F3F0FA';

export const ADMIN_HEADER_RGB = '96 72 188';

export const ADMIN_HEADER_SURFACE_RGB = '60 36 121';

export const ADMIN_HEADER_SURFACE_RGB_TW = '60_36_121';

export const ADMIN_HEADER_BACKGROUND_COLOR = `rgb(${ADMIN_HEADER_SURFACE_RGB} / 0.97)`;

export const ADMIN_HEADER_BORDER_MUTED_COLOR = `rgb(${ADMIN_HEADER_SURFACE_RGB} / 0.32)`;

export const adminPageHeaderShadowRestClass =
  'shadow-[0_14px_44px_-10px_rgb(0_0_0/0.4),0_10px_36px_-12px_rgb(60_36_121/0.38),0_4px_16px_-4px_rgb(108_78_255/0.12),inset_0_1px_0_rgb(255_255_255/0.2),inset_0_-1px_0_rgb(0_0_0/0.15)]';

export const adminPageHeaderShadowScrolledClass =
  'shadow-[0_22px_64px_-8px_rgb(0_0_0/0.52),0_14px_48px_-12px_rgb(60_36_121/0.48),0_8px_24px_-6px_rgb(108_78_255/0.16),inset_0_1px_0_rgb(255_255_255/0.24),inset_0_-1px_0_rgb(0_0_0/0.18)]';

export const adminModalPanelShadowClass =
  'shadow-[0_36px_72px_-16px_rgb(60_36_121/0.42),0_20px_48px_-14px_rgb(0_0_0/0.28),0_8px_24px_-8px_rgb(0_0_0/0.12),0_0_0_1px_rgb(60_36_121/0.1)]';

export const adminModalHeaderDepthClass =
  'shadow-[inset_0_1px_0_rgb(255_255_255/0.22),inset_0_-18px_32px_-12px_rgb(0_0_0/0.28),0_10px_28px_-8px_rgb(0_0_0/0.35)]';

export const adminModalFooterSurfaceClass = 'bg-[#F9FAFB]';

export const adminModalFooterLiftClass =
  'border-t border-[#E5E9EB] shadow-[0_-8px_24px_-14px_rgb(0_0_0/0.06),inset_0_1px_0_rgb(255_255_255/0.9)]';

export const adminBtnPrimaryClass =
  'rounded-xl bg-[#3C2479] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#322066] disabled:cursor-not-allowed disabled:opacity-50 shrink-0';

export const adminInputFocusRingClass =
  'focus:outline-none focus:ring-2 focus:ring-[#3C2479]/25 focus:border-[#3C2479]';

export const adminTabActiveClass = 'bg-[#3C2479] text-white shadow-sm';

export const adminTabInactiveClass =
  'text-[#6B778C] hover:bg-[#F3F0FA] hover:text-[#3C2479]';

export const adminScheduledPillClass = 'bg-[#F3F0FA] text-[#3C2479]';

export const adminToolbarPendingPillClass = `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold shrink-0 ${adminScheduledPillClass}`;

export const adminToolbarPendingDotClass =
  'h-1.5 w-1.5 shrink-0 rounded-full bg-[#3C2479]/55';

export const adminTableScoreChipClass =
  'inline-flex rounded-xl bg-[#F3F0FA] px-3 py-1 text-sm font-semibold text-[#3C2479]';

export const adminTablePaginationBarClass =
  'flex items-center justify-between px-5 py-4 border-t border-[#E5E9EB]';

export const adminTablePaginationMetaClass = 'text-xs text-[#9B919D]';

export const adminTablePaginationButtonClass =
  'px-3 py-1.5 text-xs font-medium rounded-lg border border-[#E5E9EB] text-[#6B778C] hover:bg-[#F8F9FB] disabled:opacity-40 disabled:cursor-not-allowed transition-colors';

export const adminPeriodTrackClass =
  'inline-flex rounded-2xl border border-[rgb(60_36_121/0.16)] bg-white p-1 gap-1 shadow-[0_4px_24px_-10px_rgb(60_36_121/0.22)]';

export const adminPeriodSegmentActiveClass =
  'rounded-xl bg-gradient-to-b from-[#4a2d95] to-[#3C2479] px-4 py-2 text-sm font-medium text-white shadow-[inset_0_1px_0_rgb(255_255_255/0.14),0_2px_10px_-3px_rgb(60_36_121/0.45)] ring-1 ring-white/10';

export const adminPeriodSegmentInactiveClass =
  'rounded-xl px-4 py-2 text-sm font-medium text-[#6B778C] transition-all duration-200 hover:bg-[#F3F0FA] hover:text-[#3C2479]';

export const adminModalOverlayClass = 'bg-gray-300 bg-opacity-75';

export const ADMIN_MODAL_WIDTH = 'min(960px, calc(100vw - 2rem))';

export const ADMIN_MODAL_MAX_HEIGHT = 'min(88vh, 820px)';

export const adminModalLayerContentClass =
  'p-0 !bg-transparent shadow-none ring-0 outline-none max-w-full overflow-visible';

export const adminModalFormLabelClass =
  'mb-1.5 block text-sm font-medium text-[#172B4D]';

export const adminModalHeaderGradientClass =
  'bg-gradient-to-br from-[#3C2479] via-[#35286e] to-[#322066]';

export const adminBtnSecondaryClass =
  'rounded-xl border border-[rgb(60_36_121/0.22)] bg-white px-4 py-2.5 text-sm font-medium text-[#3C2479] transition-colors hover:bg-[#F3F0FA] disabled:cursor-not-allowed disabled:opacity-50 shrink-0';

// Literal hex, not `${ADMIN_PRIMARY}` — Tailwind scans source statically, so an
// interpolated arbitrary value never makes it into the generated CSS.
export const adminCheckboxClass =
  'h-4 w-4 shrink-0 cursor-pointer rounded accent-[#3C2479] focus:outline-none focus:ring-2 focus:ring-[#3C2479]/25 disabled:cursor-not-allowed disabled:opacity-50';

export const adminModalDateShellClass =
  'h-10 rounded-lg border border-[#E5E9EB] transition-shadow focus-within:ring-2 focus-within:ring-[#3C2479]/25 focus-within:border-[#3C2479]';

export const adminModalAntdPickerClass =
  'w-full h-full px-3 border-none shadow-none focus:outline-none bg-transparent';

export function buildAdminModalFieldClass(isInvalid: boolean): string {
  const borderClass = isInvalid ? 'border-red-500' : 'border-[#E5E9EB]';
  return `w-full rounded-lg border px-3 py-2 text-sm text-[#172B4D] transition-colors ${adminInputFocusRingClass} ${borderClass}`;
}

/**
 * The ground to judge a transparent image against.
 *
 * Two separated tones rather than the usual near-white grid, so whatever colour
 * a logo is it contrasts with at least one of the squares: white reads against
 * the dark square at 3.4:1, black against the light one at 15.6:1, and a pale
 * tint — the case that prompted this, a pink wordmark that was invisible on
 * white — comfortably. No single flat ground can do that, and the conventional
 * pale checkerboard hides exactly the marks that most need checking.
 *
 * The pair is deliberately no wider apart than that, and the tile no larger.
 * The two requirements pull against each other — separation is what reveals a
 * mark, and it is also what makes the grid compete with one for attention — so
 * this sits at the quietest point that still clears 3:1 against white, and
 * anyone who wants the pattern gone entirely switches the ground to flat.
 */
export const checkerboardStyle = {
  backgroundColor: '#DEDEDE',
  backgroundImage:
    'linear-gradient(45deg, #8C8C8C 25%, transparent 25%), linear-gradient(-45deg, #8C8C8C 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #8C8C8C 75%), linear-gradient(-45deg, transparent 75%, #8C8C8C 75%)',
  backgroundSize: '12px 12px',
  backgroundPosition: '0 0, 0 6px, 6px -6px, -6px 0',
};

/**
 * The grounds a transparent logo can be judged against.
 *
 * The checkerboard proves transparency but competes with the artwork; the two
 * flat grounds read cleanly but each hides one end of the tonal range. Offered
 * as a switch rather than resolved to one, because no single ground does both
 * jobs — and the flat pair doubles as a check of the two things a logo actually
 * lands on in the app: the featured card's white footer, and a dark photo.
 */
export const LOGO_GROUNDS = [
  { key: 'checker', style: checkerboardStyle },
  { key: 'white', style: { backgroundColor: '#FFFFFF' } },
  { key: 'dark', style: { backgroundColor: '#26262B' } },
] as const;

export type LogoGroundKey = (typeof LOGO_GROUNDS)[number]['key'];
